// extracted by mini-css-extract-plugin
export var adjacentSlide = "_j7-9";
export var arrowButtonContainer = "_j7-5";
export var arrowButtonIcon = "_j7-6";
export var carouselArrowButton = "_j7-2";
export var carouselElementContainer = "_j7-1";
export var currentSlide = "_j7-8";
export var left = "_j7-3";
export var otherSlide = "_j7-a";
export var productCarouselContainer = "_j7-0";
export var right = "_j7-4";
export var sliderOverflow = "_j7-7";